<template>
  <div>
     <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading> 
    <div>
      <p v-if="(contactosPaciente[0] && contactosPaciente.length === 0 && contactosPaciente[0].contacto == '') || contactosPaciente.length === 1 && contactosPaciente[0].contacto == ''">El paciente “{{informacionSesion.paciente}}” no tiene un correo electrónico asociado. Por favor agregue uno.</p>
      <p v-else-if="(contactosPaciente.length > 1 && contactosPaciente[0].contacto != '') || contactosPaciente.length === 1 && contactosPaciente[0].contacto != ''">El paciente “{{informacionSesion.paciente}}” ya cuenta con datos de contacto, por favor verifica la información si es necesario<span v-if="contactosPaciente.length > 1"> y selecciona solo un correo</span>.</p>
        
    </div>
    
      <div class="mt-3" v-if="contactosPaciente.length > 0 && !loader">
        <div class="d-flex w-75" v-for="(contacto, index) in contactosPaciente" :key="index">
          <b-input-group class="mb-3 w-100">
            <div
                class="button d-flex justify-content-center align-items-center"
            >
              <b-icon
                  :icon="mapIcono(listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto).descripcion)"
                  style="color: gray;"
              />
            </div>

            <!-- Input dinámico -->
            <b-form-input
                v-model="contacto.contacto"
                :type="getTipoInput(listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto))"
                :placeholder="getPlaceholder(listaMediosContacto.find(t => t.idMedioContacto === contacto.idMedioContacto))"
                :state="validarContacto(contacto) && contacto.contacto.trim() !== ''"
                class="form-control-sm border-input "
            ></b-form-input>
          

          </b-input-group>

          <!-- Switch -->
          <b-form-checkbox
          class="m-0 p-0"
              v-if="contactosPaciente.length > 1"
              v-model="contacto.preferente"
              switch
              size="lg"
              v-b-tooltip.top.hover.v-light
              :title="'Marcar como preferente'"
             
          ></b-form-checkbox>

          <em
              class="trash_svg m-0 p-0 ml-2"
              style="cursor: pointer; position: relative; top: -8px; width: 24px;"
              v-b-tooltip.hover.topright.v-light
              title="Inactivar"
              @click="eliminarContacto(contacto, index)">
          </em>
        </div>
      </div>

      <b-row class="mt-3" v-else-if="contactosPaciente.length === 0 && !loader">
        <b-col cols="12" class="d-flex justify-content-center">
          <em class="add_tx" style="height: 24px; cursor: pointer; margin-right: 5px; margin-top: 4px;" @click="agregarContactoPaciente" v-b-tooltip.hover.topright.v-light
              title="Agregar nuevo contacto"></em>
        </b-col>
      </b-row>

        <div class="justify-content-center d-flex mt-4 mb-2">
          <b-button variant="primary" class="rounded-pill mr-5" style="min-width: 7em;" size="sm" :disabled="!contactosValidos || contactosPaciente.length === 0 || loader || loaderGuardar" @click="guardarDatosPaciente()">Enviar<b-spinner small v-if="loaderGuardar"></b-spinner></b-button>
          <b-button variant="outline-secondary" class="rounded-pill" style="min-width: 7em;" size="sm" @click="cerrarModalRecibo()">Cancelar</b-button>
        </div>

  </div>
</template>

<script>

export default {
  name: "CorreoPaciente",
  props: {
    informacionSesion: Object,
    idPacientePadre: Number,
    idPti: Number,
    idRecibo: Number
  },
  data: () => ({
    listaMediosContacto: [],
    contactosPaciente: [],
    contactosOriginales: [],
    loader: false,
    loaderGuardar: false,
    loading: false
  }),
  async created() {
    this.loader = true;
    await this.catalogoMetodosContacto();
    await this.obtenerDatosContactoPaciente();

  },
  computed: {
    contactosValidos() {
      return this.contactosPaciente.every(contacto => {
        const esValido = this.validarContacto(contacto);
        const noVacio = contacto.contacto && contacto.contacto.trim() !== '';
        return esValido && noVacio;
      });
    }
  },
  watch: {
    contactosPaciente: {
      deep: true,
      handler(nuevos) {
        nuevos.forEach((contacto, index) => {
          const original = this.contactosOriginales[index];
          if (!original) return;

          const haCambiado =
              contacto.idMedioContacto !== original.idMedioContacto ||
              contacto.contacto !== original.contacto ||
              contacto.preferente !== original.preferente;

          contacto.editar = haCambiado;
        });
      }
    }
  },
  methods: {
    cerrarModalRecibo(){
       this.$emit("cerrarModalRecibo");
    },

    nuevoContactoVacio() {
      return {
        idMedioContactoPaciente: null,
        idMedioContacto: 3,
        contacto: '',
        preferente: true,
        popoverAbierto: false,
        editar: true
      };
    },

    agregarContactoPaciente() {
      this.contactosPaciente.push(this.nuevoContactoVacio());
    },

    async catalogoMetodosContacto() {
      await this.$http.get(this.$api + "catalogos/listaMediosContacto").then((res) => {
        this.listaMediosContacto = res.data.data
      })
    },

    async obtenerDatosContactoPaciente() {
  try {
    const res = await this.$http.post(this.$api + "paciente/obtenerDatosContactoPaciente", {
      idPaciente: this.informacionSesion.idPaciente,
    });

    const data = res.data?.data;

    if (data && data.length > 0) {
      this.contactosPaciente = data
        .filter(contactoApi => contactoApi.idMedioContacto === 3)
        .map(contactoApi => ({
          idMedioContactoPaciente: contactoApi.idMedioContactoPaciente,
          idMedioContacto: contactoApi.idMedioContacto,
          contacto: contactoApi.contacto,
          preferente: contactoApi.preferente,
          popoverAbierto: false,
          editar: contactoApi.editar
        }));

       if(this.contactosPaciente.length == 0){
        console.log("entra???")
        this.agregarContactoPaciente();
      }

      this.contactosOriginales = this.contactosPaciente.map(c => ({ ...c }));
    } else {
      this.contactosPaciente = [this.nuevoContactoVacio()];
    }

  } catch (err) {
    console.error("Error al obtener datos de contacto del paciente:", err);
  } finally {
    this.loader = false;
  }
},


    seleccionarTipo(tipo, index) {
      this.contactosPaciente[index].idMedioContacto = tipo.idMedioContacto;
      this.contactosPaciente[index].contacto = '';

      this.contactosPaciente[index].popoverAbierto = false;
    },

    mapIcono(desc) {
      const d = desc.toUpperCase()
      if (d.includes('CELULAR')) return 'telephone-fill'
      if (d.includes('TRABAJO')) return 'briefcase-fill'
      if (d.includes('CASA')) return 'house-fill'
      if (d.includes('CORREO')) return 'at'
      return 'question-circle'
    },

    getTipoInput(tipo) {
      return tipo.descripcion.includes('CORREO') ? 'email' : 'tel';
    },

    getPlaceholder(tipo) {
      return tipo.descripcion.includes('CORREO')
          ? 'correo@ejemplo.com'
          : '123 456 7890';
    },

    eliminarContacto(contacto, index) {
      if (contacto.idMedioContactoPaciente == null) {
        this.contactosPaciente.splice(index, 1);
      }else{
        this.inactivarContacto(contacto.idMedioContactoPaciente);
      }
    },

    guardarDatosPaciente() {
      this.loading = true;
      // Validación 1: ningun contacto debe de ir vacio
      if (this.contactosPaciente.find(t => t.contacto.trim() === "")) {
        this.$swal.fire({
          icon: "warning",
          title: "Contacto",
          html: "Existe un contacto no valido",
        })
         this.loading = false;
        return;
      }

      // Validación 2: cada idMedioContacto debe tener al menos un preferente
      const medios = [...new Set(this.contactosPaciente.map(c => c))];

      for (const medio of medios) {
        const relacionados = this.contactosPaciente.filter(c => c.idMedioContacto === medio.idMedioContacto);
        const algunoPreferente = relacionados.some(c => c.preferente === true);

        if (!algunoPreferente) {
          this.$swal.fire({
            icon: "warning",
            title: "Falta preferente",
            html: `El medio de contacto <b>${this.listaMediosContacto.find(t => t.idMedioContacto === medio.idMedioContacto).descripcion}</b> no tiene ningún contacto marcado como preferente.`,
          });
           this.loading = false;
          return;
        }
      }

      // Validación 3: no deben repetirse combinaciones idMedioContacto + contacto (normalizado)
      const duplicados = new Set();
      for (const c of this.contactosPaciente) {
        const contactoNormalizado = this.normalizarContacto(c.contacto);
        const key = `${c.idMedioContacto}-${contactoNormalizado}`;  // Usa el valor normalizado

        if (duplicados.has(key)) {
          const descripcion = this.listaMediosContacto.find(t => t.idMedioContacto === c.idMedioContacto)?.descripcion || 'Medio';
          this.$swal.fire({
            icon: "warning",
            title: "Contacto duplicado",
            html: `Ya existe otro contacto con el mismo medio <b>${descripcion}</b> y el mismo valor <b>${c.contacto}</b>.`,
          });
           this.loading = false;
          return;
        }
        duplicados.add(key);
      }

      // Validación 4: solo un preferente por idMedioContacto
      for (const medioId of medios) {
        const relacionados = this.contactosPaciente.filter(c => c.idMedioContacto === medioId.idMedioContacto && c.preferente === true);
        if (relacionados.length > 1) {
          const descripcion = this.listaMediosContacto.find(t => t.idMedioContacto === medioId.idMedioContacto).descripcion;
          this.$swal.fire({
            icon: "warning",
            title: "Demasiados preferentes",
            html: `El medio de contacto <b>${descripcion}</b> tiene más de un contacto marcado como preferente.`,
          });
          this.loading = false;
          return;
        }
      }

        const params = {
          idPaciente: this.informacionSesion.idPaciente,
          contactosAlta: this.contactosPaciente,
        }

        this.$http.post(this.$api + "paciente/guardarDatosContactoPaciente", params).then((res) => {
          if (res.status === 200) {
            this.$swal({
        icon: "warning",
        title: "Enviar correo a paciente",
        text: "Si más adelante cancelas el recibo, el paciente ya tendrá una copia en su bandeja de entrada, ¿deseas continuar?",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
         this.enviarCorreo();
        }else{
          this.loading = false;
        }
      }); 
          }else{
            this.$swal.fire({
              icon: "error",
              title: "Hubo un error",
              text: "No se pudo guardar el contacto del paciente",
            });
          }
        }).catch((err) => {
          console.error(err);
          this.$swal.fire({
            icon: "error",
            title: "Hubo un error en el servicio",
            text: "No se pudo guardar el contacto del paciente",
          });
        }).finally(() => {
          this.loaderGuardar = false;
        });
     
    },

    enviarCorreo(){
      const envio = {
        idRecibo: this.idRecibo,
        idPti: this.idPti,
        horas: this.$horas(),
        esReciboPti: false
      };
       const correoPreferente = this.contactosPaciente.filter(contacto => contacto.preferente && contacto.idMedioContacto === 3)

      if (this.pti !== null && this.pti === true) {
        envio.esReciboPti = true;
        this.$http
            .post(this.$api + "caja/enviarCorreo", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                console.info(respuesta.data.data);
                 this.$swal.fire({
                icon: "success",
                title: "Correo enviado",
                text: "El correo se envió correctamente a la dirección: " + correoPreferente[0].contacto,
              });
               this.$emit("cerrarModalRecibo");
              }
            })
            .finally(() => {
              this.loaderRecibo = false;
                this.loading = false;
            });
      } else {
        this.$http
            .post(this.$api + "caja/enviarCorreo", envio) 
            .then((respuesta) => {
              if (respuesta.data.data) {
                 console.info(respuesta.data.data);

                 this.$swal.fire({
                icon: "success",
                title: "Correo enviado",
                text: "El correo se envió correctamente a la dirección: " + correoPreferente[0].contacto,
              });
                  this.$emit("cerrarModalRecibo");

              }
            })
            .finally(() => {
              this.loaderRecibo = false;
              this.loading = false;
            });
      }
    },

    inactivarContacto(contacto) {
      this.$http.post(this.$api + "paciente/inactivarContactoPaciente", {idMedioContactoPaciente : contacto})
      .then((res) => {
        if (res.data.data) {
           this.$swal.fire({
            icon: "success",
            title: "Contacto eliminado",
            text: "Contacto eliminado con éxito",
          });
          this.obtenerDatosContactoPaciente();
        }else{
          this.$swal.fire({
            icon: "error",
            title: "Hubo un error",
            text: "No se pudo inactivar el registro",
          });
        }
      })
    },

    esTelefono(idMedioContacto) {
      return [1, 2, 4].includes(idMedioContacto); // Teléfono Casa, Celular, Trabajo
    },
    esCorreo(idMedioContacto) {
      return idMedioContacto === 3;
    },
    validarContacto(contacto) {
      if (this.esTelefono(contacto.idMedioContacto)) {
        const numeroLimpio = contacto.contacto.replace(/\s/g, '');
        return /^\d{10}$/.test(numeroLimpio);
      }
      if (this.esCorreo(contacto.idMedioContacto)) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contacto.contacto);
      }
      return false;
    },

    normalizarContacto(contacto) {
      if (!contacto) return '';
      if (contacto.includes('@')) {
        return contacto.trim().toLowerCase();
      }
      return contacto.replace(/\D/g, '');
    },
  }
}
</script>
<style scoped>
.border-button{
  border: 1px solid #D0D0D0;
  border-radius: 8px 0px 0px 8px;
  background-color: #fff;
  color: #AFB7BE;
}

.border-button:active , .border-input:hover{
  background-color: #fff !important;
}

.border-input{
  border-radius: 0px 8px 8px 0px;
}

.list-item-contact:hover{
  background-color: #E4F2FF !important;
  border-radius: 20px;
  cursor: pointer;
}

.label-contacto-paciente{
  color: #FEA269;
  font-size: 11px;
}

.button:hover{
  background-color: white;
}

.button{
  background-color: white;
  border: 1px solid gray;
  height: 100%;
  width: 3em;
  border-radius: 5px 0px 0px 5px;
}

.btn-primary {
  color: #FFF;
  background-color: #1B81AF;
}

.btn-primary:hover {
  color: #1B81AF;
  background-color: #FFF;
}

</style>
